module.exports = __webpack_public_path__ + "media/images/emoticons/pig-711e31da0683d6e085971dfac7cebb6b.gif";